import * as React from "react";
import { Image } from "@fluentui/react-components";
import styles from "./TopNavigation.module.scss";
import { CurrentUser } from "@/components/UI/organisms/CurrentUser/CurrentUser";
import { CustomerPicker } from "../../molecules/CustomerPicker/CustomerPicker";
import { usePortalContext } from "@/context/PortalContext";
import { ContactPicker } from "../../molecules/ContactPicker/ContactPicker";
import { useSuperUserContext } from "@/context/SuperUserContext";

export interface ITopNavigationProps {
	showCustomerPicker?: boolean;
}

export function TopNavigation(props: ITopNavigationProps) {
	const { selectedCustomerId, setSelectedCustomerId } = usePortalContext();
	const { impersonatedUserId, setImpersonatedUser, isSuperUser } = useSuperUserContext();
	return (
		<div className={styles.topNav}>
			<div className={styles.logo}>
				<Image fit="contain" src={process.env.PUBLIC_URL + "/protech-logo-blue.png"} />
			</div>
			<div className={styles.nav}>
				{isSuperUser && (
					<ContactPicker
						selectedContactId={impersonatedUserId}
						placeholder="Select a user to impersonate"
						onSelectedContactChange={setImpersonatedUser}
						emptyOptionLabel="Me"></ContactPicker>
				)}
				{props.showCustomerPicker && (
					<CustomerPicker
						selectedCustomerId={selectedCustomerId}
						onSelectedCustomerChange={setSelectedCustomerId}></CustomerPicker>
				)}
				<div>
					<CurrentUser />
				</div>
			</div>
		</div>
	);
}
